import { useTranslate } from '@ur-solutions/react-hooks'
import { ExportCompanyIssuesCard } from '../components'
import { ExportSection } from '../components/ExportsSettings/components'

export function ExportIssues() {
  const translations = useTranslate({
    issues: 'common.issues',
  })

  return (
    <ExportSection header={translations.issues}>
      <ExportCompanyIssuesCard />
    </ExportSection>
  )
}
